// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__1fL4e","signatureButtonsRight":"ModalSign_signatureButtonsRight__cn2Mv"};